import axios from '@axios'

const getInitialState = () => ({
  reportData: null,
  filters: {
    storeIds: [],
    accountType: null,
    period: {
      startDate: null,
      endDate: null,
    },
  },
})

export default {
  namespaced: true,
  state: getInitialState(),

  mutations: {
    SET_REPORT_DATA(state, reportData) {
      state.reportData = reportData
    },
    CLEAN_FILTERS(state) {
      const { filters } = getInitialState()
      state.filters = filters
    },
    CLEAN_STATE(state) {
      const { filters, reportData } = getInitialState()
      state.filters = filters
      state.reportData = reportData
    },
  },

  actions: {
    async generateReport({ state, commit }) {
      const { period, storeIds, accountType } = state.filters
      const params = {
        accountType,
        startDate: period?.startDate,
        endDate: period?.endDate,
      }
      // Array vazio é omitido: o querystring.stringify geraria "storeIds=".
      if (storeIds?.length) params.storeIds = storeIds

      const response = await axios.get('/api/reports/financial/checking-account-statements/download', {
        params,
        responseType: 'blob',
      })
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const url = window.URL.createObjectURL(blob)
      commit('SET_REPORT_DATA', url)
    },

    resetFilters({ commit }) {
      commit('CLEAN_FILTERS')
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
